import {gql} from '@apollo/client';

export const TRACK_REFERRAL_LINK_CLICK = gql`
  mutation TrackReferralLinkClick($referralCode: String!) {
    trackReferralLinkClick(referralCode: $referralCode) {
      id
    }
  }
`;
